
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import RegistDataPanel from '@/components/organisms/manage/RegistDataPanel.vue'
import ManageNoticeListPanel from '@/components/organisms/manage/ManageNoticeListPanel.vue'
import { SelectItem } from '@/models/SelectItem'
import { NoticeMessageData } from '@/models/NoticeMessage'

/**
 * お知らせ一覧(管理)
 */
@Component({
  components: {
    ManageSidemenuLayout,
    RegistDataPanel,
    ManageNoticeListPanel,
  },
})
export default class ManageNoticeList extends Vue {
  /** メッセージ一覧パネル */
  @Ref()
  noticeMessageListPanel!: ManageNoticeListPanel

  /** 塾管理権限の画面か否か */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限の画面か否か */
  @Prop({ default: false })
  private isAdmin!: boolean

  /** お知らせタイプの初期値 */
  @Prop()
  private defaultNotificationTypeCode?: string

  /** お知らせタイプのリスト */
  @Prop()
  private notificationTypeList?: SelectItem[]

  /** 年の初期値 */
  @Prop()
  private defaultYearCode!: string

  /** 年のリスト */
  @Prop()
  private selectYearList!: SelectItem[]

  /** 月の初期値 */
  @Prop()
  private defaultMonthCode!: string

  /** 月のリスト */
  @Prop()
  private selectMonthList!: SelectItem[]

  /** メッセージ一覧 */
  @Prop()
  private messageList!: NoticeMessageData[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** ソートインジケータの反転 */
  @Prop()
  private sortIndicator!: boolean

  /** メッセージのソート順の変更 */
  @Prop()
  private toggleSortOrder!: () => void

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /** 行クリック時のイベント */
  @Prop()
  private eventClickElement!: (id: number) => void

  /** 登録ボタンクリック時のイベント */
  @Prop()
  private eventClickRegistNoticeButton!: () => void

  /**
   * 選択中のお知らせタイプ
   *
   * @returns お知らせタイプのコード
   */
  public currentNotificationTypeCode(): string {
    // undefinedケース 発生しないがブロックのため記述
    if (!this.noticeMessageListPanel) {
      return ''
    }
    return this.noticeMessageListPanel.currentNotificationTypeCode()
  }

  /**
   * 選択中の年
   *
   * @returns 年のコード
   */
  public currentYearCode(): string {
    // undefinedケース 発生しないがブロックのため記述
    if (!this.noticeMessageListPanel) {
      return ''
    }
    return this.noticeMessageListPanel.currentYearCode()
  }

  /**
   * 選択中の月
   *
   * @returns 月のコード
   */
  public currentMonthCode(): string {
    // undefinedケース 発生しないがブロックのため記述
    if (!this.noticeMessageListPanel) {
      return ''
    }
    return this.noticeMessageListPanel.currentMonthCode()
  }

  /** フィルターの変更を検知してイベント発火させる */
  private changeFilter(): void {
    this.$emit('changeFilter')
  }
}
